<script lang="ts">
  let {
    category,
    size = 20,
    class: cls = "",
  }: {
    category: string;
    size?: number;
    class?: string;
  } = $props();

  const icons: Record<string, string> = {
    food: "🍽️",
    transport: "🚌",
    shopping: "🛍️",
    accommodation: "🏨",
    activity: "🎯",
    ticket: "🎫",
    drink: "🍺",
    sightseeing: "📸",
    flight: "✈️",
    bus: "🚌",
    train: "🚄",
    ferry: "⛴️",
    car: "🚗",
    taxi: "🚕",
    other: "📌",
  };

  const icon = $derived(icons[category] ?? icons.other);
</script>

<span class="inline-flex items-center justify-center {cls}" style="font-size:{size}px;line-height:1" aria-hidden="true">
  {icon}
</span>
